import { Injectable } from '@angular/core';
import { DataCoreService } from '../../../../services/data-core.service';
import { CtlGasBirimDosyaPlanService } from '../ctl-gas-birim-dosya-plan.service';

@Injectable({
  providedIn: 'root'
})
export class CtlGasBirimDosyaPlanAramaService {

  constructor(private dataCoreService: DataCoreService, private service: CtlGasBirimDosyaPlanService) {}

  getData(control: any) {
          const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
          dataSource.select([]);
          
          const filterArr = [];
          if(this.service.birim) filterArr.push(['BirimKod', '=', this.service.birim]);
          dataSource.filter(filterArr);
    //    dataSource.select(['GenDosyaPlan.Ad','GenDosyaPlan.DosyaPlanKod']);

          return dataSource;
  }}
